import * as R from 'ramda';

export const getPxPosition = R.prop('pxPosition');
export const setPxPosition = R.assoc('pxPosition');

export const getPxSize = R.prop('pxSize');
export const setPxSize = R.assoc('pxSize');



// WEBPACK FOOTER //
// ../../src/project/pxDimensions.js